import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { theme, mixins, Section, media, Heading } from '@styles';
import sr from '@utils/sr';
import { srConfig } from '@config';

const { colors, fontSizes } = theme;

const StyledSkillsSection = styled(Section)`
  ${mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  padding: 50px 0;
`;

const StyledSkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  grid-gap: 10px;
  gap: 15px;
  width: 100%;
  margin-top: 25px;
`;

const StyledSkillCard = styled.div`
  ${mixins.boxShadow};
  flex: 0 0 50%;
  padding: 20px;
  border-radius: 10px;
  background-color: ${colors.darkNavy};
  color: ${colors.lightSlate};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  height: 100%; /* Ensure uniform card height */
  min-width: 240px;
`;

const StyledSkillName = styled.h4`
  color: ${colors.green};
  font-size: ${fontSizes.xl};
  margin-bottom: 10px; /* Spacing between title and description */
`;

const StyleSkillPart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
`;
const StyledSkillTitle = styled.h5`
  flex: 0 0 38%;
  color: ${colors.white};
  font-size: ${fontSizes.md};
  margin-top: 10px; /* Spacing */
  margin-bottom: 0px;
`;
const StyledSkillDescription = styled.p`
  flex: 0 0 35%;
  font-size: ${fontSizes.sm};
  margin-bottom: 0px;
  margin-top: 10px; /* Spacing */
  margin-left: 4px;
  padding-right: 2px;
`;

const StyledSkillBar = styled.div`
  flex: 0 0 27%;
  width: 100%;
  background-color: ${colors.white};
  border-radius: 5px;
  margin-top: 10px; /* Spacing */
  margin-left: 2px;
  height: 8px;
`;

const StyledSkillLevel = styled.div`
  height: 8px;
  border-radius: 5px;
  background-color: ${colors.green};
  width: ${({ level }) => level}%;
`;
const Items = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Skills = ({ skills }) => {
  return (
    <StyledSkillsSection id="skills">
      <Heading>My skills</Heading>
      <StyledSkillsGrid>
        {skills.map((skill, i) => (
          <StyledSkillCard key={i}>
            <StyledSkillName>{skill.node.frontmatter.name}</StyledSkillName>
            <Items>
              {skill.node.frontmatter.parts.map((part, j) => (
                <StyleSkillPart key={j}>
                  <StyledSkillTitle>{part.title} : </StyledSkillTitle>
                  <StyledSkillDescription>{part.details}</StyledSkillDescription>
                  <StyledSkillBar>
                    <StyledSkillLevel level={part.level} />
                  </StyledSkillBar>
                </StyleSkillPart>
              ))}
            </Items>
          </StyledSkillCard>
        ))}
      </StyledSkillsGrid>
    </StyledSkillsSection>
  );
};

export default Skills;
